import { useEffect } from 'react';

/** Lock document scroll while any facturation modal is open (ApprobationsCrudShell pattern). */
export default function useFacturationModalBodyLock(...openFlags) {
  useEffect(() => {
    if (!openFlags.some(Boolean)) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, openFlags); // eslint-disable-line react-hooks/exhaustive-deps
}
